<template>
    <div class="row my-1">
        <div class="row-icon small" style="min-heigth: 20px; min-width: 20px"></div>
        <div class="row-heading mobile-width-80"><v-skeleton-loader width="60px" type="text"></v-skeleton-loader></div>
        <div class="row-fields">
            <div class="row-field shrink">
                <div class="row-field-label"><v-skeleton-loader type="text"></v-skeleton-loader></div>
                <div class="icon grey"></div>
            </div>
            <div class="row-field shrink">
                <div class="row-field-label"><v-skeleton-loader type="text"></v-skeleton-loader></div>
                <div class="icon grey"></div>
            </div>
            <div class="row-more-icon">
                <div class="icon transparent w-inline-block" style="min-width: 50px;"><v-skeleton-loader type="button"></v-skeleton-loader></div>
                <div class="icon transparent w-inline-block" style="min-width: 50px;"><v-skeleton-loader type="button"></v-skeleton-loader></div>
            </div>
        </div>
    </div>
</template>

<script>
// Components
import { VSkeletonLoader } from "vuetify/lib/components/VSkeletonLoader";

export default {
    components: {
        VSkeletonLoader
    }
}
</script>